import { cn } from '@/lib/utils';

export function InactivePill({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-md bg-[#F2F4F7] px-1.5 py-px text-[10.5px] font-medium leading-4 text-[#475467]',
        className,
      )}
      data-testid="inactive-pill"
    >
      Inactive
    </span>
  );
}
